/**
 * API Configuration
 * Provides the base API URL that works across different environments
 */

// Get the API URL from environment variable
// In production, fallback to the Render backend if env var is missing
export const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? 'https://proyas-backend.onrender.com' 
    : 'http://localhost:5001'
);

/**
 * Gets the full URL for a file path
 * @param path - The file path (can start with / or not)
 * @returns Full URL to the file
 */
export const getFileUrl = (path: string): string => {
  if (!path) return '';
  
  // If already a full URL (starts with http), return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Clean up the path
  const cleanPath = path.replace(/^(server\/)?/, '').replace(/^\/+/, '');
  
  // Return full URL
  return `${API_BASE_URL}/${cleanPath}`;
};

/**
 * Gets the API endpoint URL
 * @param endpoint - API endpoint path
 * @returns Full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};
